export default {
  logosrow: {
    statement:
      "Nos Courtiers Hypothécaires donnent accès à 20+ institutions financières"
  },
  benefits: {
    statement:
      "Vous obtenir le meilleur taux hypothécaire possible pour l’achat le plus important de votre vie",
    best_rates: "MEILLEURS TAUX",
    best_rates_point:
      "Transparence complète sur les taux disponibles. Accédez à plus de 2,000 produits hypothécaires.",
    expert_advice: "CONSEILS D’EXPERTS",
    expert_advice_point:
      "Choisissez la meilleure hypothèque possible avec des conseils d’experts - ils travaillent pour vous, pas pour les banques.",
    seamless_process: "APPLICATION RAPIDE",
    seamless_process_point:
      "Notre technologie simplifie le processus - fini les délais et la paperasse. On s’occupe de soumettre l’application pour vous.",
    title: "Notre Mission"
  },
  whocanapply: {
    title: "Êtes-vous elligible?",
    factors: [
      'Homeowner in Ontario, Alberta or British Columbia',
      'Minimum proprety value of $250,000',
      'At least 55 years old',
      'Access up to $800,000 of tax free cash'
    ]
  },
  howitworks: {
    title: "Comment Nesto fonctionne",
    subtitle: "Simple comme 1, 2, 3",
    step1: {
      title: "Découvrez vos taux hypothécaires",
      description: "Le plan PATH Home peut vous aider à réimaginer votre style de vie. Il est donc important de consulter votre conseiller financier et d’en discuter en premier lieu avec votre famille.",
      benefit1:
        "Obtenez un aperçu complet des taux disponibles - personnalisés pour votre propre situation",
      benefit2:
        "Accédez à des offres personnalisées provenant des institutions financières les plus compétitives",
      benefit3:
        "Évitez des heures de recherche en ligne, d’appels téléphoniques, et de visites en succursales",
      perk1: "2 minutes",
      perk2: "À votre convenance",
      perk3: "24/7",
      cta: "COMPARER LES TAUX"
    },
    step2: {
      title: "Obtenez le support d'experts pour prendre la bonne décision",
      description: "Vous vous demandez comment les taux d'intérêt et l'appréciation de la maison vont vous affecter? Avez-vous quelques questions à poser? Un courtier en hypothèques peut vous aider. Les experts hypothécaires agréés (AMP) peuvent effectuer des recherches et recommander une solution à vos besoins financiers. Contactez nous.",
      benefit1:
        "Obtenez une opinion indépendante de nos Courtiers Hypothécaires - ils travaillent pour vous, pas pour les banques",
      benefit2:
        "Nous traduisons vos options hypothécaires en termes simples afin que vous preniez une décision éclairée",
      benefit3:
        "Obtenez notre soutien selon vos propres besoins - aussi peu ou autant que vous le désirez",
      benefit4: "Notre support est complètement gratuit",
      perk1: "15 minutes",
      perk2: "À votre convenance",
      perk3: "Tous les jours, 9h - 20h",
      perk4: "Par Téléphone ou Chat"
    },
    step3: {
      title: "Préparez vos documents:",
      description: "Vous nécessiterez:",
      benefit1: "Preuve que vous avez reçu un avocat indépendant",
      benefit2: "Si vos dettes sont garanties par votre résidence, vous devrez fournir des déclarations justificatives.",
      benefit3: "Vérification de votre capacité à couvrir les dépenses liées à la propriété telles que les taxes foncières, les frais de copropriété et les services publics",
      benefit4: "Une évaluation à domicile",
      benefit5: "Une procuration (le cas échéant)",
      perk1: "Application rapide",
      perk2: "Pris en charge par Nesto",
      perk3: "Statut disponible 24/7",
      legalRollover:
        `Avis juridique indépendant de votre propre avocat pour vous assurer que ce produit vous convient.`,
      legalRolloverLink:
        "conseils juridiques"
    },
    step4: {
      title: "Obtenez l'évaluation de votre maison",
      description: "Un évaluateur de maison agréé aidera à déterminer une juste valeur marchande. Ils examineront l'état de votre maison, les tendances actuelles du marché, ainsi que d'autres facteurs."
    },
    step5: {
      title: "Protégez vos intérêts",
      description: "Obtenir des conseils juridiques indépendants est l’un des meilleurs moyens de protéger vos intérêts et de vous donner confiance pour conclure l’accord."
    }
  },
  meet: {
    title: "Rencontrer l'equipe",
    subtitle: "Des Courtiers indépendants qui travaillent dans votre intérêt",
    statement:
      "Nous vous présenterons tous les produits hypothécaires disponibles, et non pas seulement ceux qui nous rapporte une meilleure commission. Nous vous dirons combien le prêteur fait, et notre commission.",
    perk1:
      "Plus de 45 ans d'expérience en tant que Courtiers Hypothécaires agréés",
    perk2: "Nos Courtiers se classent parmi les meilleurs courtiers au Canada",
    perk3:
      "Nous avons aidé des milliers de Canadiens et Canadiennes à devenir propriétaires "
  }
}



// WEBPACK FOOTER //
// ./src/i18n/translations/fr/landing.js